export default __webpack_public_path__ + "static/2-244c55c9bb99e208285f388a69d785b4.jpeg";